import {
  GET_MESSAGE_HOT,
  DELETE_MESSAGE_HOT,
  GET_MESSAGE_LIST,
  RESET_MESSAGE_LIST,
  SET_MESSAGE_ZAN,
  EMPTY_HOT,
} from '../constants/message';

export const getMessageHot = params => ({
  type: GET_MESSAGE_HOT,
  params,
});

export const deleteMessageHot = params => ({
  type: DELETE_MESSAGE_HOT,
  params,
});

export const getMessageList = params => ({
  type: GET_MESSAGE_LIST,
  params,
});

export const resetMessageList = params => ({
  type: RESET_MESSAGE_LIST,
  params,
});

export const setMessageZan = params => ({
  type: SET_MESSAGE_ZAN,
  params,
});

export const emptyHot = params => ({
  type: EMPTY_HOT,
  params,
});
